module.exports = __webpack_public_path__ + "static/media/disponivel.191486cd.svg";